var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbShowMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ib-show-more_svg__clip0_4215_1705)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#58647A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.167a5.333 5.333 0 100 10.666 5.333 5.333 0 000-10.666zM1.833 8.5a6.667 6.667 0 1113.334 0 6.667 6.667 0 01-13.334 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.971 7.362c.26.26.26.682 0 .943l-2 2a.667.667 0 01-.942 0l-2-2a.667.667 0 11.942-.943L8.5 8.89l1.528-1.528c.26-.26.683-.26.943 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ib-show-more_svg__clip0_4215_1705"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1.833 1.833)",
    d: "M0 0h13.333v13.333H0z"
  })))));
}

export default SvgIbShowMore;